import { useEffect, useState } from 'react';
import { useIsMobile } from '../../hooks/useIsMobile';
import { EASE, FONT_MONO } from '../../tokens';

const GREEN = '#22c55e';
/** Delay before the badge slides in, so it does not compete with the hero. */
const REVEAL_DELAY_MS = 1200;

/** Fixed "system operational" badge in the lower-left corner. */
export function SystemStatus() {
  const [visible, setVisible] = useState(false);
  const isMobile = useIsMobile();

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), REVEAL_DELAY_MS);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      style={{
        position: 'fixed',
        bottom: isMobile ? 16 : 24,
        left: isMobile ? 16 : 24,
        zIndex: 9000,
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        background: 'rgba(13,13,13,0.92)',
        backdropFilter: 'blur(16px)',
        border: '1px solid rgba(34,197,94,0.25)',
        borderRadius: 100,
        padding: '8px 16px 8px 12px',
        opacity: visible ? 1 : 0,
        transform: visible ? 'translateY(0)' : 'translateY(12px)',
        transition: `opacity 0.6s ${EASE}, transform 0.6s ${EASE}`,
      }}
    >
      <div
        style={{
          width: 7,
          height: 7,
          borderRadius: '50%',
          background: GREEN,
          animation: 'pulse-dot 2s ease-in-out infinite',
        }}
      />
      <span
        style={{
          fontFamily: FONT_MONO,
          fontSize: '0.62rem',
          color: GREEN,
          letterSpacing: '0.12em',
          fontWeight: 500,
        }}
      >
        SYSTEM OPERATIONAL
      </span>
    </div>
  );
}
